/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requested_Documents_EmptyInputs */

const en_task_requested_documents_empty = /** @type {(inputs: Task_Requested_Documents_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents requested yet.`)
};

const pt_br2_task_requested_documents_empty = /** @type {(inputs: Task_Requested_Documents_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum documento solicitado ainda.`)
};

/**
* | output |
* | --- |
* | "No documents requested yet." |
*
* @param {Task_Requested_Documents_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requested_documents_empty = /** @type {((inputs?: Task_Requested_Documents_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requested_Documents_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requested_documents_empty(inputs)
	return pt_br2_task_requested_documents_empty(inputs)
});